import { Controller } from "@hotwired/stimulus";

export class RemovalsController extends Controller {
  remove() {
    this.element.remove();
  }
}
